import Link from "next/link";

import { Button } from "@ocr-monorepo/ui/components/button";

export function MossClosingCta({
  title,
  description,
  href,
  label = "Get started with PdfParse ↗",
  onClick,
}: {
  title: string;
  /** Omitted on solution pages, which carry their closing message in the title. */
  description?: string;
  href: string;
  label?: string;
  onClick?: () => void;
}) {
  return (
    <section className="bg-foreground text-background">
      <div className="mx-auto flex max-w-[1440px] flex-col items-start justify-between gap-8 px-5 py-14 md:flex-row md:items-center md:px-10 lg:px-20 lg:py-16">
        <div>
          <h2 className="max-w-[820px] text-[clamp(2.25rem,4vw,3.25rem)] leading-[1.05] tracking-[-0.045em]">
            {title}
          </h2>
          {description && (
            <p className="mt-4 text-lg leading-7 text-background/75">
              {description}
            </p>
          )}
        </div>
        <Button asChild variant="secondary" size="marketing" className="shrink-0">
          <Link href={href} onClick={onClick}>
            {label}
          </Link>
        </Button>
      </div>
    </section>
  );
}
